
// components/CustomUploadAdapterPlugin.js

export function CustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new CustomUploadAdapter(loader);
  };
}

class CustomUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    const file = await this.loader.file;
    const formData = new FormData();

    formData.append("file", file);
    formData.append("fileName", file.name);
    formData.append("publicKey", "public_vD+OSO61s+MF9MumRU3Z4cMYyA0=");
    formData.append("useUniqueFileName", "true");
    formData.append("folder", "/ckeditor");

    const response = await fetch("https://upload.imagekit.io/api/v1/files/upload", {
      method: "POST",
      headers: {
        Authorization: `Basic ${btoa("private_NdPxzSbRqoy6+gV6RYsOLTkEd+k=:")}`,
      },
      body: formData,
    });

    const data = await response.json();
    if (data.url) {
      return {
        default: data.url,
      };
    } else {
      throw new Error("Upload failed");
    }
  }

  abort() {
    // Optionally handle abort
  }
}
